import generateSettings from '../helpers/Settings';
import styles from './styles';
import content from './content';

export default (container = document) => {
  const modules = container.querySelectorAll('[data-cms-module-video]');
  modules.forEach((module, i) => {
    const module_name = 'Video';
    const settingsElement = module.querySelector('[data-settings]');
    const settings = settingsElement ? generateSettings(settingsElement.innerHTML) : null;

    if (!settings) {
      return;
    }

    const styles_html = styles(settings, module_name, i);
    const content_html = content(settings, module_name, i);
    const module_width = `Section--${settings.module_width} Section--mobile-${settings['module_width--mobile']}`;

    const new_section = document.createElement('section');
    new_section.id = `Module-${module_name}--${i}`;
    new_section.dataset.sectionId = `${module_name}--${i}`;
    new_section.dataset.sectionType = '';
    new_section.className = `CMS-Module Module-${module_name} Section ${module_width}`;

    const bg_div = document.createElement('div');
    bg_div.className = 'Section__bg';
    bg_div.style.backgroundImage = `url('${settings.background_texture || ''}')`;

    const container_div = document.createElement('div');
    container_div.className = 'Section__container';
    container_div.innerHTML = content_html;

    bg_div.appendChild(container_div);
    new_section.appendChild(bg_div);
    module.innerHTML = '';
    module.appendChild(new_section);
    module.insertAdjacentHTML('beforeend', styles_html);
  });
};
